import {isObject} from './is-object.function';

export function objectIsNullUndefinedOrEmpty(value: any): boolean {
    if (value === null || value === undefined) return true;

    if (isObject(value, true)) return Object.keys(value).length === 0;

    return true;
}
